import { useEffect } from "react";
import DocumentInput from "../../../../../utils/DocumentInput";
import {
  Form,
  Input,
  Radio,
  Select,
  Divider,
  Button,
  InputNumber,
  Switch,
} from "antd";
import { useInfoConvocatoria } from "../../../../../hooks/useInfoConvocatoria";
import { useNavigate } from "react-router-dom";
import { useMaestras } from "../../../../../hooks/useMaestras";
import { InputNumero } from "../../../../../components/Mascaras/InputNumero/InputNumero";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
const { TextArea } = Input;
const { Option } = Select;

export const FormInfo = () => {
  const {
    onFinish,
    convocatoria,
    setConvocatoria,
    getLineasConvocatoria,
    categoriasDisabled,
    categoriasLC,
    isEconomico,
    handleChange,
    isBolsaConcursable,
    disabledForm,
    cargarConvocatoria,
    initialState,
    loading,
    guardarArchivo,
    portada,
    setPortada,
    setGuardoArchivo,
    fileInputRef
  } = useInfoConvocatoria();

  const { decrypt } = useEncrypt();
  const navigate = useNavigate();

  const {
    obtenerLineaConvocatorias,
    lineaConvocatorias,
    obtenerEntidades,
    entidades,
    obtenerCiclos,
    ciclos,
    obtenerLineaEstrategica,
    lineaEstrategica,
    obtenerAreas,
    areas,
  } = useMaestras();

  useEffect(() => {
    getLineasConvocatoria();
    obtenerLineaConvocatorias();
    obtenerEntidades();
    obtenerCiclos();
    obtenerLineaEstrategica();
    obtenerAreas();
  }, []);

  useEffect(()=>{
    handleChange(portada, "portada_url");
  },[portada])

  useEffect(() => {
    if (Boolean(decrypt(localStorage.getItem("editar_convocatoria")))) {
      cargarConvocatoria();
      return;
    }
    setConvocatoria(initialState);
  }, [localStorage.getItem("editar_convocatoria")]);

  const fields = [
    { name: "nombre_convocatoria", value: convocatoria.nombre_convocatoria },
    { name: "linea_convocatoria", value: convocatoria.linea_convocatoria },
    {
      name: "categoria_linea_convocatoria",
      value: convocatoria.categoria_linea_convocatoria,
    },
    { name: "entidad", value: convocatoria.entidad },
    { name: "tipo_participante", value: convocatoria.tipo_participante },
    { name: "menor_edad", value: convocatoria.menor_edad },
    { name: "ciclo", value: convocatoria.ciclo },
    { name: "linea_estrategica", value: convocatoria.linea_estrategica },
    { name: "area", value: convocatoria.area },
    { name: "cobertura", value: convocatoria.cobertura },
    { name: "esconvenio", value: convocatoria.esconvenio },
    { name: "tipo_estimulo", value: convocatoria.tipo_estimulo },
    { name: "valor_total_entg", value: convocatoria.valor_total_entg },
    { name: "bolsa_concursable", value: convocatoria.bolsa_concursable },
    { name: "num_estimulos", value: convocatoria.num_estimulos },
    { name: "modalidad", value: convocatoria.modalidad },
    { name: "descripcion_corta", value: convocatoria.descripcion_corta },
    { name: "objetivo", value: convocatoria.objetivo },
    { name: "noparticipa", value: convocatoria.noparticipa },
    { name: "perfil_participante", value: convocatoria.perfil_participante },
    { name: "portada_url", value: convocatoria.portada_url },
  ];

  return (
    <>
      <div className="container-fluid ps-md-4 pe-md-4 main-c5">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px pe-4">
          Crear convocatoria
        </div>
        <div className="sombra_card" style={{ marginBottom: "50px" }}>
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
              <div className="row">
                <div className="col-12 col-md-8 pt-0 font-size-14px font-family-Montserrat-Regular">
                  <h3 className="font-size-14px font-color-1B1C1D font-family-Montserrat-SemiBold">
                    Información general -
                    <span className="title__obligatorio font-color-DB2828 font-size-10px">
                      Todos los campos son obligatorios
                    </span>
                  </h3>
                </div>
                <div className="col-12 col-md-4 pt-0 justify-content-flex-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                </div>
              </div>
            </div>
          </div>
          <div className="form__container">
            <Form
              name="crearConvocatoriaArtistas"
              layout="vertical"
              size="large"
              onFinish={onFinish}
              initialValues={convocatoria}
              fields={fields}
            >
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="Nombre de convocatoria"
                      name="nombre_convocatoria"
                    >
                      <TextArea
                        rows={1}
                        showCount={true}
                        maxLength={1000}
                        onChange={({ target }) =>
                          handleChange(
                            target.value,
                            "nombre_convocatoria"
                          )
                        }
                      />
                    </Form.Item>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="Línea convocatoria"
                      name="linea_convocatoria"
                    >
                      <Select
                        placeholder="Seleccionar..."
                        onChange={(value) =>
                          handleChange(value, "linea_convocatoria")
                        }
                      >
                        {lineaConvocatorias.slice().reverse().map(({ id, nombre }) => (
                          <Option key={id} value={id}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="Categorías línea convocatoria"
                      name="categoria_linea_convocatoria"
                    >
                      <Select
                        mode="multiple"
                        allowClear
                        disabled={categoriasDisabled}
                        placeholder="Seleccionar"
                        onChange={(value) =>
                          handleChange(value, "categoria_linea_convocatoria")
                        }
                      >
                        {categoriasLC.map(({ id, nombre }: any) => (
                          <Option key={id} value={id}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="Entidad" name="entidad">
                      <Select>
                        {entidades.map(({ id, nombre }: any) => (
                          <Option key={id} value={nombre}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-6">
                    <Form.Item
                      label="¿Quién puede participar?"
                      name="tipo_participante"
                    >
                      <Select
                        mode="multiple"
                        allowClear
                        placeholder="Seleccionar"
                        onChange={(value) =>
                          handleChange(value, "tipo_participante")
                        }
                      >
                        <Option key={1} value={1}>Persona natural</Option>
                        <Option key={2} value={2}>Persona jurídica</Option>
                        <Option key={3} value={3}>Grupo conformado</Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="¿Participa menor de edad?"
                      name="menor_edad"
                    >
                      <Radio.Group
                        onChange={(e: any) =>
                          handleChange(e.target.value, "menor_edad")
                        }
                      >
                        <Radio value={true}>Sí</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="¿Seudónimos?" name="pseudonimo">
                      <Radio.Group>
                        <Radio value={true}>Sí</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="Ciclo" name="ciclo">
                      <Select
                        placeholder="Seleccionar"
                        onChange={(value) => handleChange(value, "ciclo")}
                      >
                        {ciclos.map(({ id, nombre }: any) => (
                          <Option key={id} value={nombre}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="Línea estratégica"
                      name="linea_estrategica"
                    >
                      <Select
                        placeholder="Seleccionar"
                        onChange={(value) =>
                          handleChange(value, "linea_estrategica")
                        }
                      >
                        {lineaEstrategica.map(({ id, nombre }: any) => (
                          <Option key={id} value={nombre}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item label="Área" name="area">
                      <Select
                        mode="multiple"
                        allowClear
                        placeholder="Seleccionar"
                        onChange={(value) => handleChange(value, "area")}
                      >
                        {areas.map(({ id, nombre }: any) => (
                          <Option key={id} value={nombre}>{nombre}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="Cobertura" name="cobertura">
                      <Select
                        placeholder="Seleccionar..."
                        onChange={(value) => handleChange(value, "cobertura")}
                      >
                        <Option key={1} value="Área">Área metropolitana</Option>
                        <Option key={2} value="Municipal">Municipal</Option>
                        <Option key={3} value="Nacional">Nacional</Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="¿Es convenio?" name="esconvenio">
                      <Radio.Group
                        onChange={(e: any) =>
                          handleChange(e.target.value, "esconvenio")
                        }
                      >
                        <Radio value={true}>Sí</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item label="Tipo de estímulo" name="tipo_estimulo">
                      <Select
                        placeholder="Seleccionar"
                        onChange={(value) =>
                          handleChange(value, "tipo_estimulo")
                        }
                      >
                        <Option value="Económico">Económico</Option>
                        <Option value="No Aplica">No Aplica</Option>
                      </Select>
                    </Form.Item>
                  </div>
                  {isEconomico && (
                    <>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                        <Form.Item
                          label="Valor total de recursos"
                          name="valor_total_entg"
                        >
                          <InputNumber
                            min={1}
                            max={10000000000}
                            defaultValue={1}
                            formatter={(value) =>
                              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value: any) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            onChange={(value: any) =>
                              handleChange(value, "valor_total_entg")
                            }
                          />
                        </Form.Item>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                        <Form.Item
                          label="Bolsa concursable"
                          name="bolsa_concursable"
                        >
                          <Switch
                            checked={isBolsaConcursable}
                            onChange={(value) =>
                              handleChange(value, "bolsa_concursable")
                            }
                          />
                        </Form.Item>
                      </div>
                    </>
                  )}
                  {!isBolsaConcursable && isEconomico && (
                    <>
                      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                        <Form.Item label="Número estímulo" name="num_estimulos">
                          <InputNumero
                            name="num_estimulos"
                            texto={convocatoria.num_estimulos}
                            setTexto={setConvocatoria}
                            alltexto={convocatoria}
                          />
                        </Form.Item>
                      </div>
                    </>
                  )}
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Form.Item
                      label="Modalidad del estímulo - opcional"
                      name="modalidad"
                    >
                      <Select
                        placeholder="Seleccionar"
                        onChange={(value) => handleChange(value, "modalidad")}
                      >
                        <Option value="Apoyo">Apoyo</Option>
                        <Option value="Pasantía">Pasantía</Option>
                        <Option value="Premio">Premio</Option>
                        <Option value="Estimulo">Estímulo</Option>
                        <Option value="Residencia - Salas">
                          Residencia - Salas
                        </Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="Imagen Portada "
                      name="portada_url"
                    >
                      <DocumentInput
                        doc={typeof (portada) == 'undefined' ? "" : portada || ""}
                        fileInputRef={fileInputRef}
                        tipos_doc=", JPG, PNG."
                        setGuardoArchivo={setGuardoArchivo}
                        on_change={(e) => {
                          setGuardoArchivo(true);
                          guardarArchivo(e);
                          e.target.value = "";
                        }}
                        onDelete={async () => {
                          return setPortada("");
                        }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <Divider style={{ margin: "0" }} />
                <div className="row" style={{ marginTop: "25px" }}>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item label="Objeto" name="objetivo">
                      <TextArea
                        rows={4}
                        maxLength={2000}
                        showCount={true}
                        onChange={({ target }) =>
                          handleChange(target.value, "objetivo")
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="Descripción corta"
                      name="descripcion_corta"
                    >
                      <TextArea
                        rows={4}
                        maxLength={2000}
                        showCount={true}
                        onChange={({ target }) =>
                          handleChange(target.value, "descripcion_corta")
                        }
                      />
                    </Form.Item>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="¿Quién no puede participar?"
                      name="noparticipa"
                    >
                      <TextArea
                        rows={4}
                        maxLength={2000}
                        showCount={true}
                        onChange={({ target }) =>
                          handleChange(target.value, "noparticipa")
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="Perfil participante"
                      name="perfil_participante"
                    >
                      <TextArea
                        rows={4}
                        maxLength={2000}
                        showCount={true}
                        onChange={({ target }) =>
                          handleChange(target.value, "perfil_participante")
                        }
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <div className="container-sticky-footer">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={() => navigate("/administrador")}
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              disabled={disabledForm || loading}
              form="crearConvocatoriaArtistas"
            >
              Guardar y Continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
